import { apiInterceptor } from 'utils/apiInterceptor';
export async function UploadFile(projectId, data) {
    let formData = new FormData();

    for (let property in data) {
        formData.append(property, data[property]);
    }

    const response = await apiInterceptor(
        `${process.env.REACT_APP_MYXP_API}/manager/livestream/products/resources?projectId=${projectId}`,
        {
            method: 'POST',
            headers: {},
            body: formData,
        }
    );

    return await response.json();
}
